import Axios from "axios";
import { useEffect, useReducer } from "react";
import { systemCode, xs_languageCode } from '../..';
import { dataFetchReducer } from "../data";
import { getConfiguration } from "../utils";

export function useFetchPsvVincPiazzSports(shouldExecute,shopContext) {
    const [state, dispatch] = useReducer(dataFetchReducer, {
        isLoading: true,
        isError: false,
    });

    function isVirtualChannelEnabled(pr, ch) {
        return shopContext.isVirtualChannelEnabled(pr, ch);
    }

    useEffect(() => {

        if (!shouldExecute) {
            return;
        }

        let didCancel = false;

        const fetchData = async (url, params, callback) => {
            dispatch({ type: 'FETCH_INIT' });
            try {
                const result = await Axios.get(url, {params});
                if (!didCancel) {
                    callback(result.data);
                }
            } catch (error) {
                console.error('Errore ' + url + ': ' + error);
                if (!didCancel) {
                    dispatch({ type: 'FETCH_FAILURE' });
                }
            }
        };
        
        const url = getConfiguration().api['psv.getActiveSports'];
        const params = {
            systemCode,
            lingua: xs_languageCode,
            hash: '',
        };
        fetchData(url, params, function(response) {
            const [vincPiazzByProviderAndSport] = parseVincPiazzSports(response, isVirtualChannelEnabled);
            const vincPiazzSports = {
                vincPiazzByProviderAndSport
            }
            dispatch({ type: 'FETCH_SUCCESS', payload: vincPiazzSports });
        });
        
        return () => {
            didCancel = true;
        };
    }, [shouldExecute]);

    return [state, dispatch];
}

export function parseVincPiazzSports(data, isVirtualChannelEnabled) {
	data = data.filter(s => isVirtualChannelEnabled(s.pr, s.cha));
    const vincPiazzByProviderAndSport = {};
   
    data.forEach(s => {
        const groupId = s.vg;
        const sport = {
            id: s.id,
            isChampionship: s.ch,
            groupId,
            desc: s.d,
            provider: s.pr
        };
        const sportId = `${sport.provider}_${sport.id}`;
        if(s.r){
            vincPiazzByProviderAndSport[sportId] = {
                'vincente': s.v,
                'piazzato2': s.p2,
                'piazzato3': s.p3,
                'isVincente':function(codScomm){return codScomm == s.v},
                'isPiazzato2':function(codScomm){return codScomm == s.p2},
                'isPiazzato3':function(codScomm){return codScomm == s.p3},
        	}
        }
        
    });

    return [vincPiazzByProviderAndSport];
}
